var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-container",
        {
          staticStyle: { overflow: "visible", "min-height": "100%" },
          attrs: { fluid: "", "pa-2": "" },
        },
        [
          _c(
            "v-row",
            { ref: "topRow", staticStyle: { "justify-content": "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "flex-col",
                  attrs: { cols: "12", sm: "5", md: "3" },
                },
                [
                  _c(
                    "v-card",
                    { staticStyle: { height: "100%" } },
                    [
                      _c("v-card-title", [_vm._v("Summary")]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-simple-table",
                            {
                              staticClass: "settings auto-height-table",
                              staticStyle: { height: "100%" },
                              attrs: { id: "settings" },
                            },
                            [
                              _c("tbody", [
                                _vm.$LOCAL &&
                                _vm.statistics.hasOwnProperty("db")
                                  ? _c("tr", [
                                      _c("td", [_vm._v("Database")]),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        { attrs: { id: "msa-database" } },
                                        [_vm._v(_vm._s(_vm.statistics.db))]
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$LOCAL &&
                                _vm.statistics.hasOwnProperty("msaFile")
                                  ? _c("tr", [
                                      _c("td", [_vm._v("MSA file")]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { id: "msa-file" } }, [
                                        _vm._v(_vm._s(_vm.statistics.msaFile)),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.statistics.hasOwnProperty("msaLDDT")
                                  ? _c("tr", [
                                      _c("td", [_vm._v("MSA LDDT")]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { id: "msa-lddt" } }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.statistics.msaLDDT.toFixed(3)
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.statistics.hasOwnProperty("cmdString")
                                  ? _c("tr", [
                                      _c("td", [_vm._v("Command")]),
                                      _vm._v(" "),
                                      _c("td", { attrs: { id: "msa-cmd" } }, [
                                        _vm._v(
                                          _vm._s(_vm.statistics.cmdString)
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.tree
                ? _c(
                    "v-col",
                    {
                      staticClass: "flex-col",
                      attrs: { cols: "12", sm: "7", md: "4" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "fill-height",
                          staticStyle: {
                            position: "relative",
                            "padding-top": "54px",
                          },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              ref: "treeLabel",
                              staticStyle: {
                                position: "absolute",
                                left: "0",
                                top: "0",
                                margin: "0",
                                padding: "16px",
                                "z-index": "1",
                              },
                            },
                            [_vm._v("Guide Tree")]
                          ),
                          _vm._v(" "),
                          _c("Tree", {
                            attrs: {
                              newick: _vm.tree,
                              order: _vm.entries.map((e) => e.name),
                              selection: _vm.structureViewerSelection.map(
                                (i) => _vm.entries[i].name
                              ),
                              reference: _vm.structureViewerReference,
                              labelWidth: _vm.treeLabelWidth,
                              labelHeight: _vm.treeLabelHeight,
                            },
                            on: {
                              newStructureSelection:
                                _vm.handleNewStructureViewerSelection,
                              newStructureReference:
                                _vm.handleNewStructureViewerReference,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "flex-col",
                  attrs: { cols: "12", md: "5", sm: "8" },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "fill-height",
                      staticStyle: {
                        position: "relative",
                        "padding-top": "54px",
                      },
                    },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticStyle: {
                            position: "absolute",
                            left: "0",
                            top: "0",
                            margin: "0",
                            padding: "16px",
                            "z-index": "1",
                          },
                        },
                        [_vm._v("Structure")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "originalWrapper",
                          staticStyle: {
                            padding: "10px",
                            height: "100%",
                            width: "100%",
                          },
                        },
                        [
                          _c("StructureViewerMSA", {
                            ref: "structViewer",
                            attrs: {
                              entries: _vm.entries,
                              selection: _vm.structureViewerSelection,
                              reference: _vm.structureViewerReference,
                              mask: _vm.visibleColumnMask,
                              selectedColumns: _vm.selectedColumns,
                              previewColumn: _vm.previewColumn,
                              previewStructureIndex: _vm.previewStructureIndex,
                              id: "structure-viewer",
                            },
                            on: {
                              loadingChange: _vm.handleStructureLoadingChange,
                              addHighlight: (i) => _vm.pushActiveIndex(i, true),
                              removeHighlight: _vm.spliceActiveIndex,
                              changePreview: _vm.changePreview,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.structureViewerSelection.length == 0
                        ? _c(
                            "v-card-text",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "calc(50% - 27px)",
                                left: "0",
                                "text-align": "center",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        No structures loaded.\n                    "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c(
                    "v-card",
                    { staticClass: "msa-viewer-card", attrs: { "pa-2": "" } },
                    [
                      _c(
                        "div",
                        { staticClass: "msa-top-left" },
                        [
                          _vm.msaViewerReady
                            ? _c("MSAConfig", {
                                attrs: {
                                  representations:
                                    _vm.msaViewerState.representations,
                                  "active-representation-id":
                                    _vm.msaViewerState.activeRepresentationId,
                                  schemes: _vm.msaViewerState.schemes,
                                  "active-scheme":
                                    _vm.msaViewerState.activeScheme,
                                  "active-scheme-source-representation-id":
                                    _vm.msaViewerState
                                      .activeSchemeSourceRepresentationId,
                                  tracks: _vm.msaViewerState.tracks,
                                  "track-display-mode":
                                    _vm.msaViewerState.trackDisplayMode,
                                  "gap-threshold": _vm.gapThreshold,
                                  "selection-count": _vm.selectedColumns.length,
                                  busy: _vm.msaViewerBusy,
                                },
                                on: {
                                  "change-representation":
                                    _vm.setMSAViewerRepresentation,
                                  "change-scheme": _vm.setMSAViewerScheme,
                                  "change-track": _vm.setMSAViewerTrackEnabled,
                                  "reset-track-defaults":
                                    _vm.resetMSAViewerTrackDefaults,
                                  "change-gap-threshold":
                                    _vm.setMSAViewerGapThreshold,
                                  "clear-selection": _vm.clearSelection,
                                  "export-selection-fasta":
                                    _vm.exportMSAViewerSelectionAsFasta,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "msa-bottom-left" },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: {
                                bottom: "",
                                transition: "fade-transition",
                                "nudge-left": "48px",
                                "nudge-top": "4px",
                                color: "primary",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              staticClass:
                                                "floating-viewer-toggle",
                                              attrs: {
                                                outlined: !_vm.showViewer,
                                                color: "primary",
                                                fab: "",
                                                dark: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleView.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _c("v-icon", [
                                            _vm._v(_vm._s(_vm.$MDI.Monomer)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.showViewer ? "Hide" : "Show") +
                                    " floating viewer"
                                ),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.structurePreviewMarker.visible,
                            expression: "structurePreviewMarker.visible",
                          },
                        ],
                        staticClass: "structure-preview-column-marker",
                        style: _vm.structurePreviewMarkerStyle,
                      }),
                      _vm._v(" "),
                      _c("div", {
                        ref: "msaViewerRoot",
                        attrs: { id: "msa-viewer-root" },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-fade-transition",
        [
          _vm.cellHover.visible
            ? _c(
                "v-card",
                {
                  ref: "cellTooltip",
                  staticClass: "msa-cell-tooltip",
                  style: _vm.cellHoverStyle,
                  attrs: { elevation: "6" },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.cellHover.alignmentRow) +
                      ". " +
                      _vm._s(_vm.cellHover.name) +
                      ", " +
                      _vm._s(_vm.cellHover.residueLabel) +
                      " (" +
                      _vm._s(_vm.cellHover.alignmentColumn) +
                      ")\n        "
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        [
          _c("v-fade-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showViewerCondition,
                    expression: "showViewerCondition",
                  },
                ],
                attrs: { id: "floating-viewer" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "elevation-12",
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "100%",
                      padding: "8px",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "row",
                          "justify-content": "space-between",
                          "align-items": "center",
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "drag-handle",
                          staticStyle: {
                            "flex-grow": "1",
                            "align-self": "stretch",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticStyle: { display: "block" },
                            attrs: { icon: "" },
                            on: { click: _vm.toggleView },
                          },
                          [
                            _c("v-icon", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$MDI.CloseCircleOutline) +
                                  "\n                            "
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "floatingWrapper",
                        staticStyle: {
                          padding: "6px",
                          height: "calc(100% - 36px)",
                          width: "100%",
                          position: "relative",
                        },
                      },
                      [
                        _vm.structureViewerSelection.length == 0
                          ? _c(
                              "v-card-text",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  top: "calc(50% - 45px)",
                                  left: "0",
                                  "text-align": "center",
                                  "z-index": "1",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            No structures loaded.\n                        "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }